import dayjs from 'dayjs';

export const dateFormat = 'YYYY-MM-DD';
export const nextDay = dayjs().add(1, 'day').format(dateFormat);
export const isSameDates = (dates: string[]) => Array.from(new Set(dates)).length === 1;
